import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import {
  RouterOutlet,
  RouterModule,
  Router,
  Event,
  RoutesRecognized,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuBarComponent } from '@ui/shared/menu-bar/menu-bar.component';
import { environment } from '@env/environment';
import { SeoRouteSyncService } from '@services/seo-route-sync.service';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MenuBarComponent, RouterModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private readonly isBrowser: boolean;
  private appInsights: ApplicationInsights | null = null;

  constructor(
    private router: Router,
    private meta: Meta,
    // Guaranteed fallback: forces SeoRouteSyncService to be constructed
    // so it can subscribe to NavigationEnd and apply SEO.
    _seoRouteSync: SeoRouteSyncService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    const indexable = environment.seo?.indexable ?? true;
    this.meta.updateTag({
      name: 'robots',
      content: indexable ? 'index,follow' : 'noindex,nofollow',
    });

    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      this.initAppInsights();

      // Optional: keep your route tree debug logging
      this.router.events
        .pipe(
          filter(
            (e: Event): e is RoutesRecognized => e instanceof RoutesRecognized,
          ),
        )
        .subscribe((e: RoutesRecognized) => {
          console.log('📦 Route tree snapshot:', e.state.root);
        });
    }
  }

  ngOnInit(): void {}

  private initAppInsights(): void {
    const cs = environment.appInsightsConnectionString ?? '';
    if (!cs) return;

    const angularPlugin = new AngularPlugin();

    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: cs,
        extensions: [angularPlugin],
        extensionConfig: {
          [angularPlugin.identifier]: { router: this.router },
        },
      },
    });

    this.appInsights.loadAppInsights();
  }
}
